import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup, ReactiveFormsModule, FormGroup, FormControl } from '@angular/forms';
import { AppState } from '../../../store';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { ReferencesGroupDefinition } from '../../../models/references-group-definition';
import { selectReferenceGroups } from '../../../store/profile/profile.state';
import { InteractionEnum } from '../../../enum/interaction.enum';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { AsyncPipe } from '@angular/common';
import { ReferencesModification } from '../../../models/references-modification';
import { selectShipmentEditorReferences } from '../../../store/shipment-editor/shipment-editor.state';
import { shipmentEditorPatchReferences } from '../../../store/shipment-editor/shipment-editor.actions';

@Component({
    selector: 'app-shipment-reference-editor',
    templateUrl: './shipment-reference-editor.component.html',
    styleUrls: ['./shipment-reference-editor.component.scss'],
    imports: [ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatSelect, MatOption, AsyncPipe]
})
export class ShipmentReferenceEditorComponent implements OnInit {

    @Input()
    referenceIndex: string;

    @Input()
    referenceDefinitions: ReferencesModification;

    formSubscription: Subscription;
    stateSubscription: Subscription;
    formGroup: FormGroup;

    constructor(private store: Store<AppState>) {
    }

    ngOnInit(): void {
        this.formGroup = new FormGroup({});
        if (this.referenceDefinitions?.grouping) {
            for (const definition of this.referenceDefinitions?.grouping) {
                this.formGroup.addControl(definition.name + this.referenceIndex, new FormControl(''));
            }
        }
        this.stateSubscription = this.store.select(selectShipmentEditorReferences).subscribe(refs => {
            this.formGroup.patchValue(refs, { emitEvent: false });
        });
        this.formSubscription = this.formGroup.valueChanges.subscribe(references => {
            this.store.dispatch(shipmentEditorPatchReferences({ references }));
        });
    }

    userChange(): void {
    }

}

